import React, { useEffect, useRef, useState } from "react";
import * as func from "../../common/athleteCommon/FunctionCalls";
import * as api from "../../common/athleteCommon/API";
import Utils from "../../common/athleteCommon/Utils";
import Select from "react-select";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { usePermissions } from "../../common/PermissionContext";
import { Link, useLocation } from "react-router-dom";
import ImageWithBasePath from "../../../core/data/img/ImageWithBasePath";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "react-bootstrap";
import Swal from "sweetalert2";

const InjuryAssessment = () => {

    const perfrmList = [{ perfrmId: 1, perfrmName: "Static and dynamic balance" }, { perfrmId: "2", perfrmName: "Agility" }, { perfrmId: "3", perfrmName: "Power" }, { perfrmId: "4", perfrmName: "Speed" }, { perfrmId: "5", perfrmName: "Endurance" }, { perfrmId: "6", perfrmName: "Other" }]

    const [centerId, setCenterId] = useState("");
    const [athleteId, setAthleteId] = useState("");
    const [injuryId, setInjuryId] = useState("");
    const [injuryAssessmentId, setInjuryAssessmentId] = useState("");
    const [dateOfAssessment, setDateOfAssessment] = useState("");
    const [palpation, setPalpation] = useState("");
    const [rangeOfMotion, setRangeOfMotion] = useState("");
    const [strengthTesting, setStrengthTesting] = useState("");
    const [specialTests, setSpecialTests] = useState("");
    const [functionalTest, setFunctionalTest] = useState("");
    const [fundamentalMovements, setFundamentalMovements] = useState("");
    const [performanceTest, setPerformanceTest] = useState("");
    const [status, setStatus] = useState("");
    const [searchInput, setSearchInput] = useState("");
    const [injuryAssessmentList, setInjuryAssessmentList] = useState<any[]>([]);
    const [centerList, setCenterList] = useState<any[]>([]);
    const [injuryList, setInjuryList] = useState<any[]>([]);
    const [athleteList, setAthleteList] = useState<any[]>([]);
    const [isEdit, setIsEdit] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [showTable, setShowTable] = useState(false);

    const formRef = useRef(null);

    const { permissionsMap } = usePermissions();
    const location = useLocation();

    const currentPath = location.pathname;
    const currentPermissions = permissionsMap[currentPath] || [];

    const customSelect = {
        control: (base) => ({
            ...base,
            // padding: '20px',
            borderRadius: '10px',
            background: '#FAFAFA',
            border: 'none',
            boxShadow: 'none', // prevents default blue border on focus
            minHeight: 'unset', // optional: removes default height if needed
        }),
        placeholder: (base) => ({
            ...base,
            color: '#aaa',
        }),
        singleValue: (base) => ({
            ...base,
            color: '#333',
        }),
        menu: (base) => ({
            ...base,
            zIndex: 9999,
        }),
    }

    useEffect(() => {
        async function fetchInjuryAssessment() {
            setIsLoading(true);
            const injuryResponse = await func.injuryAssessment(null);
            setInjuryAssessmentList(Array.isArray(injuryResponse) ? injuryResponse : []);
            setShowTable(true)
            setIsLoading(false);
        }
        fetchInjuryAssessment();
    }, [])

    const filteredData = injuryAssessmentList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value !== null && value !== undefined ? value.toString().toLowerCase() : '');
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });

    const slNoRender = (rowData, column) => {
        return column.rowIndex + 1;
    };

    const dateRender = (rowData) => {
        return <span>{formatDate(rowData.dateofAssessment)}</span>
    };
    
    const injDateRender = (rowData) => {
        return <span>{formatDate(rowData.dateOfInjury)}</span>
    };

    const palpationRender = (rowData) => {
        return <span>{rowData.palpation}</span>
    };

    const rangeOfMotionRender = (rowData) => {
        return <span>{rowData.rangeofMotion}</span>
    };

    const strengthTestRender = (rowData) => {
        return <span>{rowData.strengthTesting}</span>
    };

    const specialTestRender = (rowData) => {
        return <span>{rowData.specialTests}</span>
    };

    const funcTestRender = (rowData) => {
        return <span>{rowData.functionalTest}</span>
    };

    const fundMvmtRender = (rowData) => {
        return <span>{rowData.fundamentalMovements}</span>
    };

    const prfmncRender = (rowData) => {
        return <span>{rowData.performanceTest}</span>
    };

    const injuryAssessmentStatusRender = (rowData) => {
        return <span>{(rowData.status == 1) ? "Active" : "Inactive"}</span>
    };

    const formatDate = (date) => {
        const dateObj = new Date(date);
        const day = String(dateObj.getDate()).padStart(2, '0');
        const month = String(dateObj.getMonth() + 1).padStart(2, '0');
        const year = dateObj.getFullYear();
        return `${day}-${month}-${year}`;
    };

    const editDetails = (rowData) => {
        return (
            <Link to="#" onClick={() => editInjuryAssessment(rowData)}>
                <i className="feather-edit"></i>Edit
            </Link>
        );
    };

    const deleteDetails = (rowData) => {
        const injId = rowData.injuryAssessmentId;
        return (
            <Link to="#" onClick={() => deleteInjuryAssessment(injId)}>
                <i className="feather-trash"></i>Delete
            </Link>
        );
    };

    async function newInjuryAssessment() {
        const injuryResponse = await func.injury(null);
        setInjuryList(Array.isArray(injuryResponse) ? injuryResponse : [])
        setIsEdit(false)
        setOpenModal(true)
        setCenterId("")
        setAthleteId("")
        setInjuryId("")
        setDateOfAssessment("")
        setFunctionalTest("")
        setFundamentalMovements("")
        setPalpation("")
        setInjuryAssessmentId("")
        setPerformanceTest("")
        setRangeOfMotion("")
        setStrengthTesting("");
        setSpecialTests("")
    }

    async function editInjuryAssessment(rowData) {
        const injuryResponse = await func.injury(null);
        setInjuryList(Array.isArray(injuryResponse) ? injuryResponse : [])
        setInjuryAssessmentId(rowData.injuryAssessmentId)
        setAthleteId(rowData.athleteId)
        setInjuryId(rowData.injuryId)
        setDateOfAssessment(rowData.dateofAssessment)
        setFunctionalTest(rowData.functionalTest)
        setFundamentalMovements(rowData.fundamentalMovements)
        setPalpation(rowData.palpation)
        setPerformanceTest(rowData.performanceTest)
        setRangeOfMotion(rowData.rangeofMotion)
        setStrengthTesting(rowData.strengthTesting);
        setSpecialTests(rowData.specialTests)
        setStatus(rowData.status)
        setIsEdit(true)
        setOpenModal(true)
    }

    function deleteInjuryAssessment(injuryId: string) {
        const delteInjury = api.InjuryAssessment + "/" + injuryId + "/0";
        fetch(delteInjury, {
            method: "DELETE",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                }
            })
    }

    function handleSubmit(e) {
        e.preventDefault();
        if (!formRef.current.checkValidity()) {
            // Manually trigger native HTML5 validation message
            formRef.current.reportValidity();
        } else {
            if (isEdit) {
                updateInjuryAssessment();
            } else {
                const formData = new FormData();
                // formData.append("centerId", centerId);
                formData.append("athleteId", athleteId);
                formData.append("injuryId", injuryId);
                formData.append("dateOfAssessment", dateOfAssessment);
                formData.append("palpation", palpation);
                formData.append("rangeOfMotion", rangeOfMotion);
                formData.append("strengthTesting", strengthTesting);
                formData.append("specialTests", specialTests);
                formData.append("functionalTest", functionalTest);
                formData.append("fundamentalMovements", fundamentalMovements);
                formData.append("performanceTest", performanceTest);

                const createInjAssess = api.InjuryAssessment;
                fetch(createInjAssess, {
                    method: "POST",
                    headers: {
                        "Authorization": 'Bearer ' + Utils.getAccessToken()
                    },
                    body: formData
                })
                    .then((response) => response.json())
                    .then((result) => {
                        if (result.error == false) {
                            Swal.fire({
                                title: 'Success',
                                text: result.message,
                                icon: 'success',
                                confirmButtonText: 'OK',
                                allowOutsideClick: false,
                                allowEscapeKey: false
                            }).then((res) => {
                                if (res.isConfirmed) {
                                    window.location.reload(); // 🔁 Reload only after OK is clicked
                                }
                            });
                        } else {
                            if (result.code == 401) {
                                Utils.logoutUser();
                            }
                            Swal.fire({
                                title: 'Error',
                                text: result.message,
                                icon: 'error',
                                confirmButtonText: 'OK',
                                allowOutsideClick: false,
                                allowEscapeKey: false
                            }).then((res) => {
                                if (res.isConfirmed) {
                                    window.location.reload(); // 🔁 Reload only after OK is clicked
                                }
                            });
                        }
                    })
            }
        }
    }

    function updateInjuryAssessment() {
        const formData = new FormData();
        // formData.append("centerId", centerId);
        formData.append("athleteId", athleteId);
        formData.append("injuryId", injuryId);
        formData.append("dateOfAssessment", dateOfAssessment);
        formData.append("palpation", palpation);
        formData.append("rangeOfMotion", rangeOfMotion);
        formData.append("strengthTesting", strengthTesting);
        formData.append("specialTests", specialTests);
        formData.append("functionalTest", functionalTest);
        formData.append("fundamentalMovements", fundamentalMovements);
        formData.append("performanceTest", performanceTest);
        formData.append("status", status);

        const updateInjAssessmnt = api.InjuryAssessment + "/" + injuryAssessmentId;
        fetch(updateInjAssessmnt, {
            method: "POST",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
            body: formData
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                }
            })
    }

    return (
        <>
            {isLoading && (
                <div id="global-loader">
                    <div className="loader-img">
                        <ImageWithBasePath src="assets/img/loader.png" className="img-fluid" alt="Global" />
                    </div>
                </div>
            )}
            <div className="content container" style={{ maxWidth: "1380px", paddingTop: "10px" }}>
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row align-items-center">
                                <div className="col d-flex justify-content-between">
                                    <h4>Injury Assessment</h4>
                                    {currentPermissions.includes("add") ?
                                        <Link
                                            to="#"
                                            className="btn"
                                            onClick={() => { newInjuryAssessment() }}
                                            data-bs-toggle="tooltip"
                                            style={{ fontSize: "24px", padding: "0px" }}
                                            title="Create Injury">
                                            <i className="feather-plus" />&nbsp;
                                        </Link>
                                        : null
                                    }
                                </div>                                
                                {showTable && (
                                    <div className="col-lg-12 col-sm-12 text-end dataTables_filter">
                                        <label>
                                            <input
                                                type="text"
                                                value={searchInput}
                                                onChange={(e) => setSearchInput(e.target.value)}
                                                style={{ height: "40px" }}
                                                placeholder="Search"
                                                className="form-control"
                                            />
                                        </label>
                                    </div>
                                )}
                            </div>
                            {showTable && (
                                <div className="tab-content">
                                    <div
                                        className="tab-pane fade show active"
                                        id="nav-Recent"
                                        role="tabpanel"
                                        aria-labelledby="nav-Recent-tab"
                                        tabIndex={0}
                                    >
                                        <div className="table-responsive table-datatble">
                                            <DataTable
                                                className="table datatable"
                                                value={filteredData}
                                                paginator
                                                rows={10}
                                                rowsPerPageOptions={[10, 25, 50, 100]}
                                                // currentPageReportTemplate="{first}- {last} of {totalRecords} entries"
                                                pageLinkSize={3}
                                            >
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="slNo"
                                                    body={slNoRender}
                                                    header="Sl &nbsp; No"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="dateofInjury"
                                                    header="Date Of Injury"
                                                    body={injDateRender}
                                                    className="table-inset-btn"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="dateofAssessment"
                                                    header="Date of Assessment"
                                                    body={dateRender}
                                                    className="table-inset-btn"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="palpation"
                                                    header="Palpation"
                                                    body={palpationRender}
                                                    className="table-inset-btn"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="rangeofMotion"
                                                    header="Range Of Motion"
                                                    body={rangeOfMotionRender}
                                                    className="table-inset-btn"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="strengthTesting"
                                                    header="Strength Testing"
                                                    body={strengthTestRender}
                                                    className="table-inset-btn"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="specialTests"
                                                    header="Special Tests"
                                                    body={specialTestRender}
                                                    className="table-inset-btn"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="functionalTest"
                                                    header="Functional Test"
                                                    body={funcTestRender}
                                                    className="table-inset-btn"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="fundamentalMovements"
                                                    header="Fundamental Movements"
                                                    body={fundMvmtRender}
                                                    className="table-inset-btn"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="performanceTest"
                                                    header="Performance Test"
                                                    body={prfmncRender}
                                                    className="table-inset-btn"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="status"
                                                    header="Status"
                                                    body={injuryAssessmentStatusRender}
                                                    className="table-inset-btn"
                                                ></Column>
                                                {currentPermissions.includes("edit") ?
                                                    <Column
                                                        className="text-link"
                                                        body={editDetails}
                                                    ></Column>
                                                    : null
                                                }
                                                {currentPermissions.includes("delete") ?
                                                    <Column
                                                        className="text-link"
                                                        body={deleteDetails}
                                                    ></Column>
                                                    : null
                                                }
                                            </DataTable>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            <Modal
                show={openModal}
                size="xl"
                centered>
                <ModalHeader>
                    <ModalTitle>
                        <h4 className="mb-0 upper-case">{isEdit ? "Edit " : "Add "} Injury Assessment</h4>
                    </ModalTitle>
                    <Button
                        variant=""
                        className="btn-close"
                        onClick={() => setOpenModal(false)}
                    ></Button>
                </ModalHeader>
                <ModalBody>
                    <form ref={formRef}>
                        <div className="row">                            
                            <div className="col-lg-3">
                                <div className="input-space">
                                    <label className="form-label">Injury</label>
                                    <Select
                                        value={injuryList.find(inj => inj.injuryId === injuryId) ? {
                                            value: injuryId,
                                            label: formatDate(injuryList.find(inj => inj.injuryId === injuryId).dateOfInjury)
                                        } : null}
                                        onChange={async (e) => {
                                            setInjuryId(e.value);
                                        }}
                                        styles={customSelect}
                                        required
                                        isDisabled={isEdit}
                                        placeholder="Select Injury"
                                        options={injuryList.map(inj => ({
                                            value: inj.injuryId,
                                            label: formatDate(inj.dateOfInjury)
                                        }))}>
                                    </Select>
                                </div>
                            </div>
                            <div className="col-lg-3 mb-10">
                                <div className="input-space">
                                    <label className="form-label">Date Of Assessment</label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        required
                                        name="dateOfAssessment"
                                        value={dateOfAssessment}
                                        onChange={(e) => { setDateOfAssessment(e.target.value) }}
                                        placeholder="Enter Date of Assessment" />
                                </div>
                            </div>
                            <div className="col-lg-3 mb-10">
                                <div className="input-space">
                                    <label className="form-label">Palpation</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        required
                                        name="palpation"
                                        value={palpation}
                                        onChange={(e) => { setPalpation(e.target.value) }}
                                        placeholder="Enter Palpation" />
                                </div>
                            </div>
                            <div className="col-lg-3 mb-10">
                                <div className="input-space">
                                    <label className="form-label">Range Of Motion</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        required
                                        name="rangeOfMotion"
                                        value={rangeOfMotion}
                                        onChange={(e) => { setRangeOfMotion(e.target.value) }}
                                        placeholder="Enter Range of Motion" />
                                </div>
                            </div>
                            <div className="col-lg-3 mb-10">
                                <div className="input-space">
                                    <label className="form-label">Strength Testing</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        required
                                        name="strengthTesting"
                                        value={strengthTesting}
                                        onChange={(e) => { setStrengthTesting(e.target.value) }}
                                        placeholder="Enter Strength testing" />
                                </div>
                            </div>
                            <div className="col-lg-3 mb-10">
                                <div className="input-space">
                                    <label className="form-label">Special Tests</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        required
                                        name="specialTests"
                                        value={specialTests}
                                        onChange={(e) => { setSpecialTests(e.target.value) }}
                                        placeholder="Enter Special Tests" />
                                </div>
                            </div>
                            <div className="col-lg-3 mb-10">
                                <div className="input-space">
                                    <label className="form-label">Functional Test</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        required
                                        name="functionalTest"
                                        value={functionalTest}
                                        onChange={(e) => { setFunctionalTest(e.target.value) }}
                                        placeholder="Enter Functional Test" />
                                </div>
                            </div>
                            <div className="col-lg-3 mb-10">
                                <div className="input-space">
                                    <label className="form-label">Fundamental Movements</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        required
                                        name="fundamentalMovements"
                                        value={fundamentalMovements}
                                        onChange={(e) => { setFundamentalMovements(e.target.value) }}
                                        placeholder="Enter Fundamental Movements" />
                                </div>
                            </div>
                            <div className="col-lg-3 mb-10">
                                <div className="input-space">
                                    <label className="form-label">Performance Test</label>
                                    {/* <input
                                        type="text"
                                        className="form-control"
                                        required
                                        name="performanceTest"
                                        value={performanceTest}
                                        onChange={(e) => { setPerformanceTest(e.target.value) }}
                                        placeholder="Enter Performance Test" /> */}
                                    <Select
                                        value={perfrmList.find(prfrm => prfrm.perfrmId === performanceTest) ? {
                                            value: performanceTest,
                                            label: perfrmList.find(prfrm => prfrm.perfrmId === performanceTest)?.perfrmName
                                        } : null}
                                        onChange={async (e) => {
                                            setPerformanceTest(e.value);
                                        }}
                                        styles={customSelect}
                                        required
                                        placeholder="Select Performance Test"
                                        options={perfrmList.map(prfrm => ({
                                            value: prfrm.perfrmId,
                                            label: prfrm.perfrmName
                                        }))}>
                                    </Select>
                                </div>
                            </div>
                            <div className="col-lg-4 mb-10">
                                {isEdit ?
                                    <>
                                        <div className="row">
                                            <div className="col-lg-2" style={{ paddingTop: "1rem", marginTop: "1.5rem" }}>
                                                <label className="form-label">Status</label>
                                            </div>
                                            <div className="col-lg-2" style={{ paddingTop: "1rem", marginTop: "1.5rem" }}>
                                                <div className="form-check form-switch d-flex align-items-center justify-content-end">
                                                    <input
                                                        className="form-check-input text-end"
                                                        type="checkbox"
                                                        checked={status === '1'}
                                                        id="status"
                                                        onChange={(e) => {
                                                            setStatus(e.target.checked ? '1' : '0')
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </> : null
                                }
                            </div>
                        </div>
                        <ModalFooter>
                            <Button
                                className="btn-primary text-uppercase"
                                variant="success"
                                type="submit"
                                onClick={handleSubmit}
                            >
                                <b><i className="fas fa-save" />{isEdit ? "Update " : "Save "}</b>
                            </Button>
                        </ModalFooter>
                    </form>
                </ModalBody>
            </Modal>
        </>
    );
}

export default InjuryAssessment;